import { getField, updateField } from "vuex-map-fields";
import db from "@/firebase/firebaseInit";

const state = {
    allPositiveActions: [],
};

const actions = {
    async fetchAllPositiveActions({ commit }) {

        await db.collection('/positive_actions/en/en_positive_actions').get().then(
            (snapshot) => {
                var allPositiveActions = [];
                snapshot.forEach(doc => {
                    allPositiveActions.push(doc.data());

                });
                commit("updateField", {
                    path: "allPositiveActions",
                    value: allPositiveActions,
                })
            });
    },

    async addPositiveAction({ commit }, payload) {

        console.log(payload);

        
        

        await db.collection('/positive_actions/en/en_positive_actions').add({
            action: payload.action,
            category: payload.category,
            isActive: payload.isActive,
            tracks: payload.tracks,
            timestamp: payload.timestamp,
            userId: payload.userId,
        })
    },
};

const mutations = {
    updateField,
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
